import { useState, useEffect } from "react"
import type { Locale } from 'date-fns'
import { localeLoaders } from "../localeLoaders";

const localeCache: Record<string, Locale> = {}

interface UseDateFnsLocaleResult {
    loading: boolean;
    locale: Locale | null;
    error: Error | null;
}

const useDateFnsLocale = (localeCode: string): UseDateFnsLocaleResult => {
    const [loading, setLoading] = useState<boolean>(false)
    const [locale, setLocale] = useState<Locale | null>(null)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        if (!localeCode) throw new Error("Locale code must be provided")

        if (localeCache[localeCode]) {
            setLocale(localeCache[localeCode])
            return
        }

        setLoading(true)

        const loadLocale = async () => {
            try {
                const loadedLocale = await localeLoaders[localeCode]();
                localeCache[localeCode] = loadedLocale;
                setLocale(loadedLocale);
            } catch (err: any) {
                setError(Error(`Locale ${localeCode} not found, fallback to en-US`))

                try {
                    const loadedLocale = await localeLoaders["en-US"]();
                    localeCache[localeCode] = loadedLocale;
                    localeCache['en-US'] = loadedLocale;
                    setLocale(loadedLocale);
                } catch (e: any) {
                    setLocale(null)
                    setError(e)
                }
            } finally {
                setLoading(false)
            }
        }

        loadLocale()
    }, [localeCode])

    return {
        loading,
        locale,
        error
    }
}

export default useDateFnsLocale
